<br *ngIf="!isProfileRoute">
<br *ngIf="!isProfileRoute">
<br *ngIf="!isProfileRoute">
<br *ngIf="!isProfileRoute">
<br *ngIf="!isProfileRoute">

<!-- Main Content -->
<div 
  class="container" 
  [class.py-5]="!isProfileRoute" 
  [class.py-3]="isProfileRoute" 
  [class.profile-view]="isProfileRoute"
  [dir]="isRTL ? 'rtl' : 'ltr'"
  *ngIf="!isLoading"
>

  <!-- Not Completed State -->
  <div *ngIf="!isCompleted" class="text-center my-5 py-5 border rounded shadow-sm bg-white">
    <div class="mb-4">
      <img src="../../../assets/img/clock-icon.svg" alt="Waiting" style="width: 80px; opacity: 0.6;">
    </div>
    <h3 class="sub-title text-primary">{{ t.reportGenerating }}</h3>
    <p class="des-subtilte mt-3" style="font-size: 18px;">
      {{ t.reportGeneratingDesc }} <br>
      <strong>{{ t.checkBack }}</strong>
    </p>
    <button class="gradient-button mt-4">{{ t.backToProfile }}</button>
  </div>

  <!-- Completed State -->
  <div *ngIf="isCompleted">

    <!-- Header -->
    <div class="mb-4">
      <h3 class="mb-4 title">{{t.iterviewResult_title}}</h3>

      <div class="row mb-4">
        <div class="col-md-6">
          <div class="mb-2">
            <h6 class="mt-4 sub-title">{{t.iterviewResult_Candidate}}</h6>
            <p class="mt-3 des-subtilte">{{ candidateInfo.identifier }}</p>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-2">
            <h6 class="small-title mt-4">{{t.iterviewResult_Position}}</h6>
            <p class="mt-2 des-subtilte">{{ candidateInfo.position }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Executive Summary -->
    <div class="mb-4">
      <h6 class="sub-title mt-4">{{t.iterviewResult_Executive}}</h6>

      <div class="executive-summary-wrapper">
        <div class="executive-summary-card">
          <small>{{t.iterviewResult_Score}}</small>
          <div class="value">{{ executiveSummary.overallScore }}/100</div>
        </div>

        <div class="executive-summary-card">
          <small>{{t.iterviewResult_Recommendation}}</small>
          <div class="value">{{ executiveSummary.recommendation }}</div>
        </div>

        <div class="executive-summary-card">
          <small>{{t.iterviewResult_Duration}}</small>
          <div class="value">{{ executiveSummary.duration }}</div>
        </div>
      </div>
    </div>

    <!-- Performance Breakdown -->
    <div class="mb-4">
      <h6 class="mt-4 sub-title">{{t.iterviewResult_Performance}}</h6>

      <div class="performance-table">
        <div
          class="performance-row"
          *ngFor="let item of performanceBreakdown; let last = last"
          [class.no-border]="last"
        >
          <!-- Left -->
          <div class="left">
            <div class="icon-wrapper" [style.background-color]="item.iconBgColor"[class.me-2]="isRTL" [class.ms-2]="!isRTL">
              <img [src]="item.icon" [alt]="getPerformanceTitle(item)" class="icon-img">
            </div>

            <div class="mt-2 ms-2" [class.me-2]="isRTL" [class.ms-2]="!isRTL">
              <h6 class="title">{{ getPerformanceTitle(item) }}</h6>
              <p class="description">{{ item.description }}</p>
            </div>
          </div>

          <!-- Score Circle -->
          <div class="score-wrapper">
            <svg class="progress-ring" width="52" height="52">
              <circle class="progress-ring-bg" stroke="#e5e7eb" stroke-width="4" fill="transparent" r="22" cx="26" cy="26"/>
              <circle
                class="progress-ring-circle"
                [attr.stroke]="item.scoreColor"
                stroke-width="4"
                fill="transparent"
                r="22" cx="26" cy="26"
                [style.stroke-dasharray]="getCircumference()"
                [style.stroke-dashoffset]="getStrokeDashoffset(item.score)"
              />
            </svg>
            <div class="score-text" [style.color]="item.scoreColor">
              {{ item.score }}%
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Question Review -->
    <div class="mt-5" *ngIf="questions.length > 0">
      <h6 class="mt-4 sub-title">{{"iterviewResult_Question" | translate}}</h6>

      <div class="performance-table">
        <div
          class="performance-row simple-row"
          *ngFor="let question of questions; let i = index; let last = last"
          [class.no-border]="last"
        >
          <div class="simple-content">
            <p class="question-label small-title mb-2">
              <strong>{{ t.question }}:</strong> {{ question.text }}
            </p>
            <p class="answer-text mt-2">{{ question.answer }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- AI Insights -->
    <div class="mt-5">
      <h6 class="mt-4 sub-title">{{"iterviewResult_Insights" | translate}}</h6>

      <div class="performance-table">
        <div class="performance-row simple-row">
          <div class="simple-content">
            <p class="insight-label mb-2"><strong>{{ t.keyStrengths }}:</strong></p>
            <p class="insight-text mb-0">{{ aiInsights.keyStrengths }}</p>
          </div>
        </div>

        <div class="performance-row simple-row">
          <div class="simple-content">
            <p class="insight-label mb-2"><strong>{{ t.keyConcerns }}:</strong></p>
            <p class="insight-text mb-0">{{ aiInsights.keyConcerns }}</p>
          </div>
        </div>

        <div class="performance-row simple-row no-border">
          <div class="simple-content">
            <p class="insight-label mb-2"><strong>{{ t.overallAssessment }}:</strong></p>
            <p class="insight-text mb-0">{{ aiInsights.overallAssessment }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Download Button -->
    <div [class.text-end]="!isRTL" [class.text-start]="isRTL">
      <button class="gradient-button" (click)="downloadPDF()">
        {{ t.downloadPdf }}
      </button>
    </div>

  </div>
</div>

<!-- CV Section - Only show when NOT in profile route -->
<section class="cv-section" *ngIf="!isProfileRoute">
  <div class="container">
    <div class="text-center">
      <h3 class="titlle">{{ 'cvCover.title' | translate }}</h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-7 px-md-5">
        <p class="title-bulid">{{ 'cvCover.subtitle' | translate }}</p>
        <p class="section-text">{{ 'cvCover.description' | translate }}</p>
        <div class="btn-container">
          <button class="gradient-button">{{ 'cvCover.button' | translate }}</button>
        </div>
      </div>
      <div class="col-12 col-md-5 mb-md-4 mt-5 mt-md-0 text-center">
        <img class="img-fluid" src="../../../assets/img/Frame_2095587929-removebg-preview.png" alt="CV Image" />
      </div>
    </div>
  </div>
</section>